import { useMemo } from "react";
import { resolveTokens } from "@outpave/ds";
import type { ThemePresetName } from "@outpave/ds";
import type { ColorScheme } from "context/ColorSchemeContext";
import type { ThemeColors } from "utils/themeContextHelper";
import { resolveBrandIdentity } from "theme/brandIdentity";

/** The draft's token map for one scheme, resolved the way the app resolves the saved record. */
export const useDraftTokens = (
  colors: Partial<ThemeColors>,
  inherited: Partial<ThemeColors> | null | undefined,
  scheme: ColorScheme,
  preset: ThemePresetName,
): Record<string, string> =>
  useMemo(
    () =>
      resolveTokens(scheme, {
        identity: resolveBrandIdentity(colors, inherited),
        preset,
      }),
    [colors, inherited, scheme, preset],
  );
